import { supabase } from "./supabaseClient";

export async function fetchLedProducts() {
  const { data, error } = await supabase
    .from("led_products")
    .select("*")
    .eq("active", true)
    .order("sort_order", { ascending: true });
  if (error) return { products: [], error };
  return { products: data || [], error: null };
}

// ── Dipakai oleh halaman admin: ambil SEMUA produk (termasuk yang
// nonaktif), supaya marketing tetap bisa mengelola produk yang lagi
// disembunyikan dari katalog publik. ──
export async function fetchAllLedProducts() {
  const { data, error } = await supabase
    .from("led_products")
    .select("*")
    .order("sort_order", { ascending: true });
  if (error) return { products: [], error };
  return { products: data || [], error: null };
}

export async function fetchLedProductById(id) {
  const { data, error } = await supabase.from("led_products").select("*").eq("id", id).single();
  return { product: data || null, error };
}

export async function submitLedQuoteRequest(payload) {
  const { data, error } = await supabase.from("led_quote_requests").insert(payload).select().single();
  if (error) throw error;
  return data;
}

// ── Kalkulasi layout LED wall dari ukuran dinding yang diinginkan ──
// Murni matematika (tidak ada eval/kode dinamis) — jumlah cabinet
// dibulatkan ke kelipatan penuh terdekat (tidak ada "cabinet setengah"),
// jadi ukuran akhir bisa sedikit berbeda dari input.
export function computeLedLayout(product, wallWidthM, wallHeightM) {
  if (!product || !wallWidthM || !wallHeightM) return null;

  const cabW = product.cabinet_width_mm / 1000;
  const cabH = product.cabinet_height_mm / 1000;

  const cols = Math.max(1, Math.round(wallWidthM / cabW));
  const rows = Math.max(1, Math.round(wallHeightM / cabH));

  const actualWidthM = cols * cabW;
  const actualHeightM = rows * cabH;
  const areaM2 = actualWidthM * actualHeightM;

  const pitchM = product.pixel_pitch_mm / 1000;
  const resolutionW = Math.round(actualWidthM / pitchM);
  const resolutionH = Math.round(actualHeightM / pitchM);

  const totalCabinets = cols * rows;
  const totalWeightKg = totalCabinets * product.cabinet_weight_kg;
  const avgPowerW = product.power_avg_w_per_m2 ? areaM2 * product.power_avg_w_per_m2 : null;
  const maxPowerW = product.power_max_w_per_m2 ? areaM2 * product.power_max_w_per_m2 : null;
  const estimatedPrice = product.price_per_cabinet ? totalCabinets * product.price_per_cabinet : null;

  return {
    cols, rows, totalCabinets,
    actualWidthM, actualHeightM, areaM2,
    resolutionW, resolutionH,
    totalWeightKg, avgPowerW, maxPowerW, estimatedPrice,
  };
}
